import { render } from "./menu.vue?vue&type=template&id=54f3232a&scoped=true"
import script from "./menu.vue?vue&type=script&lang=js"
export * from "./menu.vue?vue&type=script&lang=js"

import "./menu.vue?vue&type=style&index=0&id=54f3232a&lang=scss&scoped=true"
import "./menu.vue?vue&type=style&index=1&id=54f3232a&lang=scss"
script.render = render
script.__scopeId = "data-v-54f3232a"

export default script